<template>
  <div class="new-order__main">
    <div class="container">
      <div class="new-order__main-title">Select Service</div>
      <div class="new-order__part">
        <div :key="listKey" class="service__list">
          <div
            v-for="service of services"
            :key="service.id"
            class="service__item"
            :class="{'service__item--active': service.active}"
            :style="service.active ? { borderColor: service.color } : {}"
            @click="selectService(service)"
          >
            <div class="service__item-check" v-if="service.active" :style="{ backgroundColor: service.color }">
              <i class="ri-check-line"></i>
            </div>
            <div class="service__item-icon" :style="{ backgroundColor: (service.color || '#0290FC') + '15', color: service.color || '#0290FC' }">
              <i :class="cut(service.icon) || 'ri-truck-line'"></i>
            </div>
            <div class="service__item-name">{{ service.name }}</div>
            <div class="service__item-price">${{ service.price }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  name: 'PublicNewOrderService',
  data() {
    return {
      listKey: Math.random()
    }
  },
  computed: {
    ...mapState({
      services: s =>
        s.payment.services.map(s => {
          return {...s, active: false}
        })
    })
  },
  async created() {
    await this.getServices()
  },
  methods: {
    ...mapActions({
      getServices: 'payment/fetchServices'
    }),
    ...mapMutations({
      setService: 'newOrder/setService'
    }),
    selectService(service) {
      this.services.forEach(s => (s.active = false))
      service.active = true
      this.listKey = Math.random()
      this.setService(service)
    },
    cut(iconDom) {
      if (!iconDom) return
      const start = iconDom.indexOf('="') + 2
      const end = iconDom.indexOf('">')
      return iconDom.slice(start, end)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/styles/_variables.scss';

.new-order {
  &__part {
    border-radius: 16px;
    margin-bottom: 14px;
  }
  &__main {
    margin-bottom: 20px;
    &-title {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
    }
  }
}

.service {
  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  &__item {
    position: relative;
    border: 2px solid $grey_extra_light;
    border-radius: 16px;
    padding: 16px;
    background-color: $white;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    &:hover {
      border-color: #c0c4cc;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }

    &--active {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);

      &:hover {
        transform: translateY(-2px);
      }
    }

    &-check {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }

    &-icon {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-bottom: 10px;
    }

    &-name {
      font-weight: 600;
      font-size: 15px;
      margin-bottom: 6px;
      color: #303133;
    }

    &-price {
      font-size: 18px;
      font-weight: 700;
      color: #0290FC;
    }
  }
}

@media (max-width: 480px) {
  .service__list {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .service__item {
    flex-direction: row;
    align-items: center;
    text-align: left;
    padding: 10px 14px;
    border-radius: 10px;
    border-width: 1.5px;

    &-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      font-size: 16px;
      margin-bottom: 0;
      margin-right: 12px;
      flex-shrink: 0;
    }

    &-name {
      margin-bottom: 0;
      font-size: 14px;
      flex: 1;
    }

    &-price {
      font-size: 15px;
      margin-left: 12px;
      flex-shrink: 0;
    }

    &-check {
      top: -6px;
      right: -6px;
      width: 18px;
      height: 18px;
      font-size: 11px;
    }
  }
}
</style>
